import request from '@/utils/request'
import { method } from '@/utils/constant'

const { POST, GET } = method

export default {
  // =========================== 协会人员角色 start ====================
  // 获取协会人员列表
  async getAssoList(params) {
    return request({ method: POST, url: `/admin/background/assoUser/list`, params })
  },
  // 改变人员状态
  async changeRoleStatus(params) {
    return request({ method: POST, url: `/admin/background/assoUser/modifyStatus`, params })
  },
  async organizationList() {
    return request({ method: GET, url: `/admin/background/assoUser/organizationList` })
  },
  async getUserInfo(params) {
    return request({ method: GET, url: `/admin/background/assoUser/getUser/${params.userId}` })
  },
  async getPrivileges() {
    return request({ method: GET, url: `/admin/background/assoUser/getPrivileges` })
  },
  async assoUserUpdate(params) {
    return request({ method: POST, url: `/admin/background/assoUser/update`, params })
  },
  // =========================== 协会人员角色 end ====================
  // =========================== 会员数据 start ====================
  // 会员数据列表
  async getMemberList(params) {
    return request({ method: POST, url: `/admin/background/member/list`, params })
  },
  async getProvince() {
    return request({ method: GET, url: `/admin/region/province` })
  },
  async getQueryList(params) {
    return request({ method: GET, url: `/admin/background/member/queryList/${params.busiType}` })
  },
  async exportMembers(params) {
    const requestData = {
      method: POST,
      url: `/admin/background/member/exportMembers`,
      responseType: 'blob',
      params,
    }
    return request(requestData)
  },

  async fieldsMapping(params) {
    return request({ method: POST, url: `/admin/background/member/fieldsMapping`, params })
  },

  async memberUpdateBatch(params) {
    return request({ method: POST, url: `/admin/background/member/updateBatch` })
  },

  // 查询会员缴费记录
  async getMemberPaymentList(params) {
    return request({ method: POST, url: `/admin/payment/admin/list`, params })
  },

  // =========================== 会员数据 end ====================

  // =========================== 准会员数据 start ================
  async getAssociateMem(params) {
    return request({ method: POST, url: `/admin/approval/associateMem/list`, params })
  },

  // 清理准会员数据
  async cleanAssociateMem(params) {
    return request({ method: POST, url: `/admin/approval/cleanAssociateMem`, params })
  },

  async getFilterTypeList(params) {
    return request({ method: GET, url: `/admin/approval/listQueryCondition` })
  },

  // 组织管理
  async addOrg(params) {
    return request({ method: POST, url: '/admin/admin/organization/addOrg', params })
  },

  async saveOrg(params) {
    return request({ method: POST, url: '/admin/admin/organization/saveOrg', params })
  },

  async modifyOrgStatus(params) {
    return request({ method: POST, url: '/admin/admin/organization/modifyOrgStatus', params })
  },

  async searchOrg(params = {}) {
    return request({ method: POST, url: '/admin/admin/organization/searchOrg', params })
  },

  async deleteOrg(id) {
    return request({ method: POST, url: '/admin/admin/organization/deleteOrg/' + id })
  },

  async saveUser(params) {
    return request({ method: POST, url: '/admin/admin/user', params })
  },

  async searchUser(params) {
    return request({ method: POST, url: '/admin/admin/user/search', params })
  },

  async existsUser(user) {
    return request({ method: POST, url: '/admin/admin/user/exists/' + user })
  },

  async updatePassword(params) {
    return request({ method: POST, url: '/admin/admin/user/updatePassword', params })
  },

  async sendLoginNameAndPassword(id) {
    return request({ method: POST, url: '/admin/admin/user/sendLoginNameAndPassword/' + id })
  },

  async freeze(uid) {
    return request({ method: POST, url: `/admin/admin/user/${uid}/freeze` })
  },

  async unFreeze(uid) {
    return request({ method: POST, url: `/admin/admin/user/${uid}/unFreeze` })
  },

  async deleteUser(uid) {
    return request({ method: 'DELETE', url: `/admin/admin/user/` + uid })
  },

  async getPrivilege(uid) {
    return request({ method: GET, url: '/admin/admin/user/userPrivilege/' + uid })
  },

  async setPrivilege(userId, privilegeIds) {
    return request({
      method: POST,
      url: '/admin/admin/user/userPrivilege',
      params: { userId, privilegeIds },
    })
  },

  // 会费标准管理
  async standardApply(id) {
    return request({ method: POST, url: '/admin/member/standard/apply/' + id })
  },

  async standardList() {
    return request({ method: POST, url: '/admin/member/standard/list' })
  },

  async standardSaveDraft(id, draftStandard) {
    return request({
      method: POST,
      url: '/admin/member/standard/saveDraft',
      params: { id, draftStandard },
    })
  },

  async updateAssociationId(id, associationId) {
    return request({
      method: POST,
      url: '/admin/background/member/updateAssociationId',
      params: { id, associationId },
    })
  },
}
